/**
 * Composable to fix viewport height layout shifts on iPhone 16+ in Chrome
 * When the bottom navigation hides/shows, viewport units change causing layout shifts
 * This composable sets a stable CSS custom property for viewport height
 */
export const useStableViewport = () => {
  const { $isIPhone } = useNuxtApp();
  let resizeTimeout = null;
  if (process.client) {
    onMounted(() => {
      if (!$isIPhone) return;

      const setViewportHeight = () => {
        const height = window.visualViewport
          ? window.visualViewport.height
          : window.innerHeight;
        const vh = height * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      };
      setTimeout(setViewportHeight, 100);

      let lastOrientation =
        window.orientation || screen.orientation?.angle || 0;

      const handleOrientationChange = () => {
        const currentOrientation =
          window.orientation || screen.orientation?.angle || 0;
        if (currentOrientation !== lastOrientation) {
          lastOrientation = currentOrientation;
          // Delay to allow the orientation change to complete
          setTimeout(setViewportHeight, 300);
        }
      };

      window.addEventListener("orientationchange", handleOrientationChange);

      onUnmounted(() => {
        window.removeEventListener(
          "orientationchange",
          handleOrientationChange
        );
        if (resizeTimeout) clearTimeout(resizeTimeout);
      });
    });
  }
};
